// components/OffcanvasForm.js
import React from "react";
import "./OffcanvasForm.css";
import { useState } from "react";
import Swal from "sweetalert2";

const OffcanvasForm = ({ isOpen, onClose }) => {
 const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
    });
  
    // Step 2: Handle Input Change
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
    
      try {
        const response = await fetch("https://topfaculty.co.in/api/web_lead.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData), // Must be JSON encoded!
        });
    
        const result = await response.json();
        console.log("API Response:", result);
    
        if (result.status === "success") {
          Swal.fire("Success!", result.message, "success");
          setFormData({ name: "", phone: "", email: "" });
        } else {
          Swal.fire("Error!", result.message, "error");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        Swal.fire("Error!", "Network error or invalid response", "error");
      }
    };

  return (
    <div className={`offcanvas-form ${isOpen ? "open" : ""}`}>
      <div className="col-md-12">
        <div className="rs-banner-section3">
          <div className="register-form">
            <div
              className="form-title text-center"
              style={{ padding: "15px 68px 18px", marginBottom: "15px" }}
            >
              <h4 className="title">
                How Can We <span class="warning-color">Help You?</span>{" "}
              </h4>
            </div>
            <button className="close-btn" onClick={onClose}>
              ×
            </button>
            <div
              className="form-group text-center"
              style={{ padding: "0 17px 0px" }}
            >
              <form
              
                id="contact-form"
                className="contact-form"
                method="post"
                onSubmit={handleSubmit}
              >
                <div className="row">
                  <div className="col-lg-12">
                    <input
                      className="from-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      type="text"
                      placeholder="Name"
                      id="name"
                      required="required"
                    />
                  </div>
                  <div className="col-lg-12">
                    <input
                      className="from-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      type="number"
                      placeholder="Phone Number"
                      id="phone_number"
                      required="required"
                    />
                  </div>
                  <div className="col-lg-12">
                    <input
                      className="from-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      type="email"
                      placeholder="E-Mail"
                      id="email"
                      required="required"
                    />
                  </div>

                  <div className="col-lg-12">
                    <input
                      style={{ lineHeight: "0px" }}
                      type="submit"
                      defaultValue="SUBMIT"
                      className="wpcf7-form-control wpcf7-submit "
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffcanvasForm;
